#import "../../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation ApplyInvoiceSigningDocument(
  $input: ApplyInvoiceSigningDocumentInput!
) {
  applyInvoiceSigningDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
